import { Component, AfterViewInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements AfterViewInit {

  constructor(
    public el: ElementRef,
  ) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.el.nativeElement.classList.add('initial');
    }, 500);
  }

}
